/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1RealmState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_REALM_STATE_ENTITY_NAME = 'ixm.userauth.v1.Realm';
export const ixmUserauthV1RealmStateEntity = new schema.Entity<IxmUserauthV1RealmState>(IXM_USERAUTH_V1_REALM_STATE_ENTITY_NAME, {}, { idAttribute: 'realmId' });

